//terms that are "CD", a 'value' term
module.exports = [
  //numbers
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'eighteen',
  'nineteen',
  'twenty',
  'thirty',
  'forty',
  'fifty',
  'sixty',
  'seventy',
  'eighty',
  'ninety',
  'hundred',
  'thousand',
  'million',
  'billion',
  'trillion',
  'quadrillion',
  'quintillion',
  'sextillion',
  'septillion',
  'octillion',
  'nonillion',
  'decillion',

  //months
  "january",
  "february",
  // "march",
  "april",
  // "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
  "jan", "feb", "mar", "apr", "jun", "jul", "aug", "sep", "oct", "nov", "dec", "sept", "sep",

  //days
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
].reduce(function (h, s) {
  h[s] = "CD"
  return h
}, {})



//////////////////
// WEBPACK FOOTER
// ./~/nlp_compromise/src/data/lexicon/values.js
// module id = 193
// module chunks = 0